import { Dispatch } from '@reduxjs/toolkit';

import callGraphQLApi from '@helpers/callGraphQLApi';
import {
  REQUEST_USER_ORGANIZATION,
  REQUEST_USER_ORGANIZATION_FAILURE,
  REQUEST_USER_ORGANIZATION_SUCCESS,
} from '../actions';
// import { AccountProfile, Action, OrganizationPayload } from '../models';

// const testDispatch = (dispatch: Dispatch): any => (
//   action:
//     | Action<typeof REQUEST_USER_ORGANIZATION, void>
//     | Action<typeof REQUEST_USER_ORGANIZATION_SUCCESS, OrganizationPayload>
//     | Action<typeof REQUEST_USER_ORGANIZATION_FAILURE, unknown>
// ) => {
//   if (action.type === REQUEST_USER_ORGANIZATION_SUCCESS) {
//     return dispatch({
//       type: REQUEST_USER_ORGANIZATION_SUCCESS,
//       payload: {
//         me: {
//           organization: {
//             ...action.payload.me.organization,
//             jsondata: {
//               ...action.payload.me.organization.jsondata,
//               accountProfile: AccountProfile.TRIAL,
//               billing: {
//                 ...action.payload.me.organization.jsondata.billing,
//                 mediaProcessedMs_lastUpdated: '2019-05-01T23:09:45.681Z',
//                 mediaProcessedMs: 190 * 60_000,
//               },
//             },
//           },
//         },
//       },
//     });
//   }
//   return dispatch(action);
// };
export interface ServiceFetchUserOrgResponse {
  me: {
    organization: {
      id: string;
      name: string;
      jsondata: any;
      mediaUsageMs: number;
    };
    userSettings: {
      key: string;
      value: any;
    }[];
  };
}
export const serviceFetchUserOrg =
  () => async (dispatch: Dispatch, getState: () => any) => {
    const query = `
      query {
        me {
          organization {
            id
            name
            jsondata
            mediaUsageMs
          }
          userSettings {
            key
            value
          }
        }
      }
    `;

    return await callGraphQLApi<ServiceFetchUserOrgResponse>({
      actionTypes: [
        REQUEST_USER_ORGANIZATION,
        REQUEST_USER_ORGANIZATION_SUCCESS,
        REQUEST_USER_ORGANIZATION_FAILURE,
      ],
      query,
      variables: {},
      dispatch, // : testDispatch(dispatch),
      getState,
      bailout: undefined,
    });
  };
